





































import useMessagingFilters from "@/composables/useMessagingFilters";
import useMessagingStatusFilters from "@/composables/v2.1/useMessagingStatusFilters";
import { computed, defineComponent, Ref, ref } from "@vue/composition-api";
import { BButton, BForm, BFormInput, BInputGroup, VBTooltip } from "bootstrap-vue";

export default defineComponent({
    components: {
        BButton,
        BForm,
        BFormInput,
        BInputGroup,
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    setup() {
        const { getActiveFilter, setActiveFilter } = useMessagingFilters();
        const searchKeyword: Ref<string> = ref(getActiveFilter.value.keyword ?? ""); // We store the search keyword locally first, so we can persist it after pressing the submit button.

        const applySearch = (): void => {
            // Allow length of 0 (empty string) to clear search filter.
            if (searchKeyword.value.length > 0 && searchKeyword.value.length < 3) {
                return;
            }

            // To avoid searching over all chats, clearing the search means setting the status filter to new and load those chats from "new"
            if (searchKeyword.value.length === 0) {
                resetSearch();
                return;
            }

            // By changing the activeFilter object, the computed in messagingInbox got triggered.
            // When initially search, we like to search across all status filters, so we set the active status filter to undefined.
            setActiveFilter({ status: undefined, keyword: searchKeyword.value, page: 1 });
        };

        const resetSearch = (): void => {
            searchKeyword.value = "";

            const { statusFilters } = useMessagingStatusFilters();
            setActiveFilter({ status: statusFilters.new, page: 1, keyword: "" });
        };

        const showResetButton = computed(
            () => searchKeyword.value !== getActiveFilter.value.keyword || searchKeyword.value?.length > 2
        );

        return {
            showResetButton,
            searchKeyword,
            activeFilter: getActiveFilter,
            applySearch,
            resetSearch,
        };
    },
});
